import React, { useEffect, useMemo, useRef } from "react";
import "./AddBranch.css";
import { Link, useParams } from "react-router-dom";
import { useAppStore, useBranchStore } from '../../../stores'
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import withReactContent from "sweetalert2-react-content";
//toast
const toastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
};

//sweetalert
const MySwal = withReactContent(Swal);
const loadBranches = async ({ id, setBranches, setDegree }, cb) => {
    try {
        const res = await fetch(`/api/course/degrees/${id}`);
        if (res.status !== 200) {
            const message = (await res.json()).message;
            throw Error(message);
        }
        const degree = (await res.json()).degree;
        const branches = degree.branches;
        console.log(degree);
        setBranches(branches);
        setDegree(degree);
        cb && cb();
    } catch (error) {
        console.log(error);
        toast.error(error.message, toastOptions);
        cb && cb();
    }
}

const fetchAddBranch = async ({ name, code, degree, addBranch }, cb) => {
    try {
        const res = await fetch(`/api/super-admin/branches`, {
            method: 'POST',
            body: JSON.stringify({ name, code, degree }),
            headers: {
                'content-Type': "application/json"
            }
        });
        if (res.status !== 200) {
            const message = (await res.json()).message;
            throw Error(message);
        }
        const branch = (await res.json()).branch;
        addBranch(branch);
        cb && cb();
        MySwal.fire("Branch added successfully");
        
    } catch (error) {
        console.log(error);
        toast.error(error.message, toastOptions);
        cb && cb();
    }
}
const AddBranch = () => {
    const degreeId = useParams().id;
    const branchForm = useRef(null);

    const addBranch = useBranchStore(state => state.addBranch);
    const addAllBranches = useBranchStore(state => state.addAllBranches);
    const branches = useBranchStore(state => state.branches);
    const degree = useBranchStore(state => state.degree);
    const setDegree = useBranchStore(state => state.setDegree);
    const showLoading = useAppStore(state => state.showLoading);
    const hideLoading = useAppStore(state => state.hideLoading);
    const loading = useAppStore(state => state.loading);

    useEffect(() => {
        showLoading();
        loadBranches({ id: degreeId, setBranches: addAllBranches, setDegree: setDegree }, hideLoading);
    }, [degreeId]);
    if (loading) {
        showLoading();
    }
    const handleBranchForm = async (e) => {
        e.preventDefault();
        e.target.disabled=true;
        let code = branchForm.current.code.value;
        let name = branchForm.current.name.value;
        if (!code || !name) {
            toast.error("Please fill the required details", toastOptions);
            e.target.disabled=false;
            return;
        }
        name = name.replaceAll(/\s/g, ' ');
        code = code.replaceAll(/\s/g, '');
        if (name.length < 1 || code.length < 1) {
            toast.error("Please fill the required details", toastOptions);
            e.target.disabled=false;
            return;
        }
        await fetchAddBranch({ name, code, addBranch, degree: degreeId });
        e.target.disabled=false;
    }
    return (
        <>
            {/* <ToastContainer /> */}
            <form className=" p-4 m-0" style={{ width: "99%" }} ref={branchForm}>
                <h1 className="mainHeading">Welcome!</h1>
                <h5 className="mainHeading subheading">Add branches within degree</h5>
                <h3 className="mainHeading mt-4">
                    Add branches to ❛{degree.name}❜
                </h3>
                <div className="row" id="addDegree">
                    <div className="form-group col-md-4">
                        <label for="Degree" className="addDlabel">
                            Branch Name
                        </label>
                        <input
                            type="text"
                            className="form-control addD"
                            placeholder="Enter branch name"
                            name="name"
                        />
                        <div className="form-text">Eg: Computer science engineering</div>
                    </div>

                    <div className="form-group col-md-4">
                        <label for="years" className="addDlabel">
                            Branch Code
                        </label>
                        <input
                            type="text"
                            className="form-control addD"
                            placeholder="Enter branch code"
                            name="code"
                        />
                        <div className="form-text">Eg: CSE</div>
                    </div>
                    <div
                        className="form-group col-md-4"
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        <button
                            className="addDegreebtn"
                            style={{ width: "65%", maxWidth: "10rem" }}
                            type="submit"
                            onClick={handleBranchForm}
                        >
                            Add Branch
                        </button>
                    </div>
                </div>
            </form>
            <div className="row p-3 m-0" style={{ width: "100%", overflowX: "auto" }}>
                {branches.map((branch) =>
                (<div class="col-md-4 mt-4">
                    <Link className="card branchcard" to={`/super-admin/branch/${branch._id}`}>
                        <div class="card-body">
                            <h5 class="card-title">{branch.code}</h5>
                            <h6 class="card-subtitle mb-2 ">{branch.name}</h6>
                        </div>
                    </Link>
                </div>
                )
                )}
            </div>
        </>
    );
};

export default AddBranch;
